<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a
              @click="openPage('/gym_attendance')"
              class="btn-grey"
            ><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                     <b-form-select name="branch" v-model="branch_id" @change="changeBranch" >
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Member</label>
                </b-col>
                <b-col sm="10">
                      <model-select  @searchchange="searchMember"  :options="optionsMember" class="border-bottom" name="member" v-validate="'required'" v-model="addData.member_id"></model-select>
                  <span class="error">{{ errors.first('member') }}</span>
                </b-col>
              </b-row>
               <!-- <b-row class="mb-20">
                <b-col sm="2">
                  <label>Classes Schedule</label>
                </b-col>
                <b-col sm="10">
                  <div class="custom-search-select">
                    <model-select :options="dataClassSchedule" class="w-100" name="classes_schedule" v-validate="'required'" v-model="editData.classes_schedule_id"></model-select>
                    <span class="error">{{ errors.first('classes_schedule') }}</span>
                  </div>
                </b-col>
              </b-row> -->
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Date</label>
                </b-col>
                <b-col sm="10">
                      <flat-pickr :config="config" v-model="addData.created_at" name="date" class="w-100"></flat-pickr>
                  <!-- <b-form-input v-model="addData.created_at" name="email" type="date"></b-form-input> -->
                  <span class="error">{{ errors.first('created_at') }}</span>
                </b-col>
              </b-row>
               <b-row class="mb-20">
                <b-col sm="2">
                  <label>Attendance Type</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="addData.attendance_type_id" v-validate="'required'" >
                    <option :value="null">Please select</option>
                    <option v-for="item in attendance_type" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('cancel.branch') }}</span>
                  <span class="error">{{ errors.first('send_date') }}</span>
                </b-col>
              </b-row>


              <div class="text-right">
                <button
                  type="submit"
                  class="btn-primary"
                >Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";
import { quillEditor } from "vue-quill-editor";
import { ModelSelect } from 'vue-search-select'
import moment from 'moment'
import Mixin from '../../mixins/memberMixin'
export default {
  name: "addEvent",
  mixins:[Mixin],
  data: function() {
    return {
      dataClassSchedule: [
        { value: null, text: 'Please select' }
      ],
      editorOption: {
        // modules: {
        //   toolbar: [
        //     ['bold', 'italic', 'underline', 'strike'],
        //     ['blockquote', 'code-block'],
        //     [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }],
        //   ]
        // }
      },
       config: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d'
      },
      config: {
        altInput: true,
        altFormat: 'j F Y H:i',
        dateFormat: 'Y-m-d H:i',
        enableTime: true,
        enableSeconds: true,
        time_24hr: true
      },
      imageData: "",
      name: "",
      description: "",
      branch_id:null,
      dataBranch: [],
      send_date: "",
      studio_id: null,
      classes_id: null,
      promo_code_id: null,
      dataMember:[],
       optionsMember: [
        { value: null, text: 'Please select' }
      ],
      class_schedule:[],
      classes_schedule_id:'',
      attendance_type:[],
      attendance_type_id:'',
      member_id:'',
      status: null,
      file: "",
      options: [
        { value: null, text: "Please select" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" }
      ],
      optStudio: [],
      optClasses: [],
      optPromoCode: [],
      addData:{
         attendance_type_id:'',
         classes_schedule_id:'',
         member_id:'',
         branch_id: '',
         created_at:new Date().toISOString(),
         from: 1
      }
    };
  },
  components: {
    ModelSelect,
    quillEditor,
  },
  methods: {
      changeBranch(event) {
        console.log(event)
      this.addData.branch_id = event
      this.getMember()

       this.getClassSchedule()

    },
    validateRegister() {
      this.$validator.validateAll().then(result => {
        if (result) {
          axios.defaults.headers.common[
            "X-Access-Token"
          ] = Auth.Session.get().paradigm_token;

          const roleId = Auth.Session.get().paradigm_role
          if (roleId == 6 || roleId == '6') {
              this.addData.branch_id = Auth.Session.get().paradigm_branch_id
          }

          axios
            .post("fitness/v1/history/gym_attendance/manual_add", this.addData)
            .then(response => {
              // console.log('test', response)
              this.$router.push("/class_attendance");
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            })
            .catch(error => {
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
        }
      });
    },
    openPage(event) {
      this.$router.push(event);
    },
    previewImage: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    async changeClass(event) {
      // console.log(event)
      let chass = this.class_schedule.find(x => x.id == event)
      console.log(chass)
      let tgl = await moment(this.addData.created_at).format('YYYY-MM-DD') + ' '+chass.classes_time.time_start
      console.log(tgl)
      this.addData.created_at = new Date(tgl).toISOString()
      // axios
      //   .get("fitness/v1/classes?studio_id=" + event)
      //   .then(response => {
      //     this.optClasses = response.data.data.rows;
      //     // console.log('test', response.data.data.rows)
      //   })
      //   .catch(error => {
      //     console.log("error", error);
      //   });
    },
    async getClassSchedule() {
      axios.get('fitness/v1/classes_schedule/all').then(response => {
        // console.log(response.data.data.rows)
        var getRealData = response.data.data.rows
        for (var i = 0; i < getRealData.length; i++) {
          var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: getRealData[i].id, text: getRealData[i].class.name + ', ' + getRealData[i].studio.name + ', (' + getRealData[i].classes_day.name + ', ' + (getRealData[i].classes_time.time_end).slice(0,-3) + '-' + (getRealData[i].classes_time.time_end).slice(0,-3) + ')'})
          this.dataClassSchedule.push(dataComplete)
        }
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeDate() {
      console.log(this.created_at)
      // this.getClassSchedule()
    },
    fetchData() {
      this.getMember()
      const roleId = Auth.Session.get().paradigm_role
       axios.get('fitness/v1/attendance/attendance_type?' ).then(response => {
        this.attendance_type = response.data.data.rows

        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      // this.getClassSchedule()
       axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
        if (roleId == 6 || roleId == '6') {
          this.dataBranch = this.dataBranch.filter(
            (item) => item.id == Auth.Session.get().paradigm_branch_id
          )
        }
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    const roleId = Auth.Session.get().paradigm_role
    this.fetchData();

    if (roleId == 6 || roleId == '6') {
        // this.addData.branch_id = Auth.Session.get().paradigm_branch_id
        this.branch_id = Auth.Session.get().paradigm_branch_id
    }
  }
};
</script>

<style>
</style>
